import cx from 'classnames';
import SmallLoader from '../Loader/SmallLoader';
import Svg from '../SVG/SVG';

const Button = (props) => {
  const {
    text,
    block,
    type = 'button',
    disabled,
    className,
    onClick,
    children,
    bg,
    svg,
    loading = false,
    loaderColor,
    loaderSize = 16,
    loaderPosition = 'left', // left | right | replace
    ...otherProps
  } = props;

  const buttonClassName = cx(
    'btn',
    `${bg}-bg`,
    block && 'block',
    disabled && 'disabled',
    className
  );

  const showLoaderOnly = loading && loaderPosition === 'replace';
  const content = (
    <>
      {loading && loaderPosition === 'left' && (
        <span className="btn__loader btn__loader_left" style={{ marginRight: 8 }}>
          <SmallLoader size={loaderSize} color={loaderColor || (bg === 'pink' ? '#fff' : '#000')} />
        </span>
      )}
      {!showLoaderOnly && text && <span className="btn__text">{text}</span>}
      {loading && loaderPosition === 'right' && (
        <span className="btn__loader btn__loader_right" style={{ marginLeft: 8 }}>
          <SmallLoader size={loaderSize} color={loaderColor || (bg === 'pink' ? '#fff' : '#000')} />
        </span>
      )}
      {showLoaderOnly && (
        <SmallLoader size={loaderSize} color={loaderColor || (bg === 'pink' ? '#fff' : '#000')} />
      )}
      {!showLoaderOnly && svg && <Svg name={svg} />}
      {/* render children (e.g. AntD icons) so callers can pass icon components */}
      {children}
    </>
  );

  return (
    <button
      onClick={onClick}
      type={type}
      className={buttonClassName}
      disabled={disabled || loading}
      {...otherProps}
    >
      {content}
    </button>
  );
};

export default Button;
